import * as React from 'react';
import { ReactElement } from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { UIContext } from '../../context/UIContext';


const GenericErrorPage = ({
    icon,
    title,
    description,
    leftButtonText,
    rightButtonText,
    actionLeftButton,
    actionRightButton
}: {
    icon?: ReactElement;
    title: string;
    description?: string;
    leftButtonText?: string;
    rightButtonText?: string;
    actionLeftButton?: () => void;
    actionRightButton?: () => void;
}) => {
    const { isMobile, isTablet } = React.useContext(UIContext);


    return (
        <>
            {!(isMobile || isTablet) && (
                <Box sx={{ marginX: '112px', marginY: '138.5px' }}>
                    <Card variant="outlined" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
                        <Box sx={{ marginTop: '24px', marginBottom: '8px' }}>{icon}</Box>
                        <Typography variant='h2'>{title}</Typography>
                        <Typography variant='body2' sx={{ marginTop: '8px', marginBottom: '32px' }}>{description}</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', marginBottom: '24px' }}>
                            {leftButtonText && <Button
                                variant="outlined"
                                size="large"
                                onClick={actionLeftButton}
                            >{leftButtonText}</Button>}
                            {rightButtonText &&<Button
                                variant="contained"
                                size="large"
                                onClick={actionRightButton}
                            >{rightButtonText}</Button>}
                        </Box>
                    </Card>
                </Box>)}
            {(isMobile || isTablet) && (
                <Box sx={{ backgroundColor: 'background.paper', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%',
                    padding: '40px', margin: '-24px'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center',  justifyContent: 'flex-start', flexGrow: '1', marginX: '32px' }}>
                        <Box sx={{ marginTop: '24px', marginBottom: '8px' }}>{icon}</Box>
                        <Typography variant='h2'>{title}</Typography>
                        <Typography variant='body2' sx={{ textAlign: 'center', marginTop: '8px', marginBottom: '32px' }}>{description}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '24px', margin: '16px', gap: '16px', marginTop: 'auto' }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={actionRightButton}
                        >{rightButtonText}</Button>
                        {leftButtonText && <Button
                            variant="outlined"
                            size="large"
                            onClick={actionLeftButton}
                        >{leftButtonText}</Button>}
                    </Box>
                </Box>
            )
            }
        </>
    );
};

export default GenericErrorPage;
